import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { makeProfile } from "@client.pages/Login/reducer";
import Dropdown from "@client.components/Dropdown";
import Pages from "@client.enums/pages";
import "./ProfileMenu.scss";

export const ProfileMenu = () => {
  const { t } = useTranslation();
  const user = useSelector(makeProfile);
  const navigate = useNavigate();
  const renderCustomContent = () => (
    <div className="profile-menu">
      {user.firstName.charAt(0)}
      {user.lastName.charAt(0)}
    </div>
  );
  return (
    <Dropdown
      items={[
        {
          label: t("components.ProfileMenu.logout"),
          value: Pages.Logout,
        },
      ]}
      valueKey="value"
      labelKey="label"
      renderCustomContent={renderCustomContent}
      onSelect={(val) => {
        navigate(val);
      }}
    />
  );
};
